import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { saveProfessional } from "../../redux/actions/professionalActions";
import { handleErrorMessage } from "../../utils/functions";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "../common/Button";

export default function FormAdd(props) {
  const dispatch = useDispatch();
  const prof = useSelector((state) => state.professionalReducers);
  let { status, closeFormAdd } = props;
  const { t } = useTranslation("common");
  const [enableDate, setEnableDate] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    register,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onChange",
    defaultValues: {
      level: "",
      field: "",
      school: "",
      location: "",
      from: "",
      time_professional: "A",
      to: "",
    },
  });

  const onSubmitData = (data) => {
    dispatch(saveProfessional(data));
    closeFormAdd();
  };

  useEffect(() => {
    reset({
      level: "",
      field: "",
      school: "",
      location: "",
      from: "",
      time_professional: "A",
      to: "",
    });
  }, [reset, closeFormAdd]);

  useEffect(() => {
    setEnableDate(false);

    register("time_professional", {
      required: true,
    });
  }, [register]);

  return (
    <>
      {status && (
        <form
          action=""
          className="w-full animate__animated animate__fadeIn animate__faster"
          onSubmit={handleSubmit(onSubmitData)}
        >
          <div className="w-full md:flex md:mb-5">
            <div className="py-2 md:py-0 md:w-1/2 mx-2">
              <Controller
                name="level"
                id="level"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("professional.error.level_required"),
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ:.,*#-]{3,}$/,
                    message: t("professional.error.level_invalid"),
                  },
                }}
                render={({ field }) => (
                  <TextField
                    type="text"
                    id="level"
                    name="level"
                    label={t("professional.level")}
                    variant="outlined"
                    className="w-full"
                    error={errors.level ? true : false}
                    helperText={t(handleErrorMessage(prof, "level"))}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      max: new Date().toISOString().slice(0, 10),
                    }}
                    {...field}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="level"
                render={({ message }) => (
                  <p className="mt-1 text-sm text-red-500">{message}</p>
                )}
              />
            </div>
            <div className="py-2 md:py-0 md:w-1/2 mx-2">
              <Controller
                name="field"
                id="field"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("professional.error.field_required"),
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ:.,*#]{3,}$/,
                    message: t("professional.error.field_invalid"),
                  },
                }}
                render={({ field }) => (
                  <TextField
                    type="text"
                    id="field"
                    name="field"
                    label={t("professional.field")}
                    variant="outlined"
                    className="w-full"
                    error={errors.field ? true : false}
                    helperText={t(handleErrorMessage(prof, "field"))}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      max: new Date().toISOString().slice(0, 10),
                    }}
                    {...field}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="field"
                render={({ message }) => (
                  <p className="mt-1 text-sm text-red-500">{message}</p>
                )}
              />
            </div>
            <div className="py-2 md:py-0 md:w-1/2 mx-2">
              <Controller
                name="school"
                id="school"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("professional.error.school_required"),
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ:.,*#-]{3,}$/,
                    message: t("professional.error.school_invalid"),
                  },
                }}
                render={({ field }) => (
                  <TextField
                    type="text"
                    id="school"
                    name="school"
                    label={t("professional.school")}
                    variant="outlined"
                    className="w-full"
                    error={errors.school ? true : false}
                    helperText={t(handleErrorMessage(prof, "school"))}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      max: new Date().toISOString().slice(0, 10),
                    }}
                    {...field}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="school"
                render={({ message }) => (
                  <p className="mt-1 text-sm text-red-500">{message}</p>
                )}
              />
            </div>
          </div>
          <div className="md:flex">
            <div className="py-2 md:py-0 md:w-4/12 mx-2">
              <Controller
                name="location"
                id="location"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: t("professional.error.location_required"),
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ:.,*#-]{3,}$/,
                    message: t("professional.error.location_invalid"),
                  },
                }}
                render={({ field }) => (
                  <TextField
                    type="text"
                    id="location"
                    name="location"
                    label={t("professional.location")}
                    variant="outlined"
                    className="w-full"
                    error={errors.location ? true : false}
                    helperText={t(handleErrorMessage(prof, "location"))}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      max: new Date().toISOString().slice(0, 10),
                    }}
                    {...field}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="location"
                render={({ message }) => (
                  <p className="mt-1 text-sm text-red-500">{message}</p>
                )}
              />
            </div>
            <div className="md:flex">
              <div className="py-2 md:py-0 md:w-full mx-2">
                <Controller
                  name="from"
                  id="from"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: t("professional.error.from_date"),
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      type="date"
                      id="from"
                      name="from"
                      label={t("professional.from")}
                      variant="outlined"
                      className="w-full"
                      error={errors.from ? true : false}
                      helperText={t(handleErrorMessage(prof, "from"))}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        max: new Date().toISOString().slice(0, 10),
                      }}
                      {...field}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="from"
                  render={({ message }) => (
                    <p className="mt-1 text-sm text-red-500">{message}</p>
                  )}
                />
              </div>
              <div className="py-2 md:py-0 md:w-10/12 mx-2">
                <InputLabel htmlFor="time_professional">
                  {t("professional.to")}
                </InputLabel>
                <Select
                  id="time_professional"
                  name="time_professional"
                  className="w-full md:my-1"
                  onChange={(event) => {
                    event.target.value === "P"
                      ? setEnableDate(true)
                      : setEnableDate(false);
                    setValue("time_professional", event.target.value);
                  }}
                  native
                  inputProps={{
                    name: "time_professional",
                    id: "time_professional",
                  }}
                >
                  <option value="A">{t("experience.actually")}</option>
                  <option value="P">{t("experience.dateNormal")}</option>
                </Select>
              </div>
              {enableDate && (
                <div className="py-2 md:py-0 md:w-full mx-2">
                  <Controller
                    name="to"
                    id="to"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: t("professional.error.from_date"),
                      },
                    }}
                    render={({ field }) => (
                      <TextField
                        type="date"
                        id="to"
                        name="to"
                        label={t("professional.to")}
                        variant="outlined"
                        className="w-full"
                        error={errors.to ? true : false}
                        helperText={t(handleErrorMessage(prof, "to"))}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          max: new Date().toISOString().slice(0, 10),
                        }}
                        {...field}
                      />
                    )}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="to"
                    render={({ message }) => (
                      <p className="mt-1 text-sm text-red-500">{message}</p>
                    )}
                  />
                </div>
              )}
            </div>
            <div className="md:w-2/12 flex justify-center mx-2">
              <Button
                status={prof.button}
                text={t("professional.addbtn")}
                icon="fa fa-check"
              />
            </div>
          </div>
        </form>
      )}
    </>
  );
}
